import { render, staticRenderFns } from "./editcategory.vue?vue&type=template&id=59667714&scoped=true"
import script from "./editcategory.vue?vue&type=script&lang=js"
export * from "./editcategory.vue?vue&type=script&lang=js"
import style0 from "./editcategory.vue?vue&type=style&index=0&id=59667714&prod&scoped=true&lang=css"
import style1 from "./editcategory.vue?vue&type=style&index=1&id=59667714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59667714",
  null
  
)

export default component.exports